module.exports = __webpack_public_path__ + "img/logo-black.09c642b1.png";